(function () {
  'use strict';

  /* ── Overlay positioning constants (necklace) ── */
  var OVL_CX     = 0.5;
  var OVL_CY     = 515 / 1080;
  var OVL_D      = 300 / 1080;
  var REF_CX     = 540 / 1080;
  var REF_CY     = 826 / 1080;
  var REF_OPACITY = 0.05;

  /* Both base images — overlay pre-rendered on EVERY base slide */
  var ALLOWED_BASES = ['/files/CONN-BLANKGOL.png', '/files/CONN-BLANKSIL.png'];

  var CDN_BASE = 'https://cdn.shopify.com/s/files/1/0827/9172/7443/files/';
  var selectedCounty = null;
  var selectedMaterial = 'gold';

  /* ── Helpers ── */

  function isBaseImage(src) {
    if (!src) return false;
    var clean = src.split('?')[0];
    for (var i = 0; i < ALLOWED_BASES.length; i++) {
      if (clean.indexOf(ALLOWED_BASES[i]) !== -1) return true;
    }
    return false;
  }

  function getEngravingUrl(key) {
    var urls = window.countyNecklaceUrls || {};
    var url = urls[key];
    return (url && url.indexOf('/files/') !== -1) ? url : CDN_BASE + key + '.png';
  }

  function ensureOverlays(container) {
    var main = container.querySelector('.cno-main');
    if (!main) {
      /* Main overlay */
      main = document.createElement('div');
      main.className = 'county-necklace-overlay cno-main';
      main.style.cssText =
        'position:absolute;display:none;pointer-events:none;z-index:6;border-radius:50%;overflow:hidden';
      var img = document.createElement('img');
      img.className = 'cno-img';
      img.style.cssText = 'display:block;width:100%;height:100%;object-fit:contain';
      img.alt = '';
      img.draggable = false;
      img.decoding = 'sync';
      main.appendChild(img);
      container.appendChild(main);

      /* Reflection overlay */
      var refl = document.createElement('div');
      refl.className = 'county-necklace-overlay cno-refl';
      refl.style.cssText =
        'position:absolute;display:none;pointer-events:none;z-index:5;border-radius:50%;overflow:hidden;opacity:' +
        REF_OPACITY + ';transform:scaleY(-1)';
      var rImg = document.createElement('img');
      rImg.className = 'cno-img';
      rImg.style.cssText = 'display:block;width:100%;height:100%;object-fit:contain';
      rImg.alt = '';
      rImg.draggable = false;
      rImg.decoding = 'sync';
      refl.appendChild(rImg);
      container.appendChild(refl);
    }
    return {
      main: container.querySelector('.cno-main'),
      refl: container.querySelector('.cno-refl')
    };
  }

  function positionEl(el, imgEl, container, cx, cy) {
    var imgRect = imgEl.getBoundingClientRect();
    var conRect = container.getBoundingClientRect();
    if (imgRect.width === 0 || imgRect.height === 0) return;

    var imgL = imgRect.left - conRect.left;
    var imgT = imgRect.top - conRect.top;
    var refSize = Math.min(imgRect.width, imgRect.height);
    var size = refSize * OVL_D;
    var px = imgL + imgRect.width * cx;
    var py = imgT + imgRect.height * cy;

    el.style.width  = size + 'px';
    el.style.height = size + 'px';
    el.style.left   = (px - size / 2) + 'px';
    el.style.top    = (py - size / 2) + 'px';
  }

  function getProductImage(container) {
    return container.querySelector('.product__modal-opener img') ||
           container.querySelector('.product__media img');
  }

  /**
   * Collect every gallery slide container whose image is a base image.
   * Returns an array of { container, imgEl } objects.
   */
  function getAllBaseContainers() {
    var results = [];
    var viewers = document.querySelectorAll('[id^="GalleryViewer-"]');
    viewers.forEach(function (viewer) {
      var slides = viewer.querySelectorAll('.product__media-item');
      slides.forEach(function (slide) {
        var container = slide.querySelector('.product-media-container');
        if (!container) return;
        var imgEl = getProductImage(container);
        if (!imgEl) return;
        var src = imgEl.currentSrc || imgEl.src || '';
        if (isBaseImage(src)) {
          results.push({ container: container, imgEl: imgEl });
        }
      });
    });
    return results;
  }

  /* ── Core update — pre-renders overlay on ALL base slides at once ── */

  function updateAllOverlays() {
    /* Hide every existing overlay first */
    document.querySelectorAll('.county-necklace-overlay').forEach(function (el) {
      el.style.display = 'none';
    });

    if (!selectedCounty) return;

    var key = selectedCounty + '_' + selectedMaterial;
    var url = getEngravingUrl(key);
    if (!url) return;

    /* Stamp overlay + reflection onto every base slide */
    var bases = getAllBaseContainers();
    bases.forEach(function (b) {
      var els     = ensureOverlays(b.container);
      var mainImg = els.main.querySelector('.cno-img');
      var reflImg = els.refl.querySelector('.cno-img');

      if (mainImg.getAttribute('data-loaded') !== url) {
        mainImg.setAttribute('data-loaded', url);
        mainImg.src = url;
        reflImg.setAttribute('data-loaded', url);
        reflImg.src = url;
      }

      els.main.style.display = 'block';
      els.refl.style.display = 'block';
      positionEl(els.main, b.imgEl, b.container, OVL_CX, OVL_CY);
      positionEl(els.refl, b.imgEl, b.container, REF_CX, REF_CY);
    });
  }

  /* ── State readers ── */

  function readMaterial() {
    var fieldset = document.querySelector('fieldset[data-option-type="material"]');
    if (!fieldset) return 'gold';
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    return (checked && checked.value.toLowerCase().indexOf('silver') !== -1) ? 'silver' : 'gold';
  }

  function readCounty() {
    var select = document.querySelector('[data-county-select]');
    if (select && select.value) return select.value;
    var radio = document.querySelector('fieldset[data-option-type="county"] input[type="radio"]:checked');
    return radio ? radio.value : null;
  }

  /* ── Event binding ── */

  function bindEvents() {
    /* County select / radio */
    document.querySelectorAll('[data-county-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        selectedCounty = this.value || null;
        updateAllOverlays();
      });
    });

    document.querySelectorAll('fieldset[data-option-type="county"] input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (this.checked) {
          selectedCounty = this.value;
          updateAllOverlays();
        }
      });
    });

    /* Material radio */
    document.querySelectorAll('fieldset[data-option-type="material"] input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var m = readMaterial();
        if (m !== selectedMaterial) {
          selectedMaterial = m;
          setTimeout(updateAllOverlays, 120);
        }
      });
    });

    /* Resize — reposition all overlays */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (selectedCounty) updateAllOverlays();
      }, 150);
    });

    /* Image load — an image may have loaded lazily, re-check bases */
    document.querySelectorAll('[id^="GalleryViewer-"] img').forEach(function (img) {
      img.addEventListener('load', function () {
        if (selectedCounty) updateAllOverlays();
      });
    });

    /* Slide class changes — variant switch may swap gallery images */
    document.querySelectorAll('[id^="Slider-Gallery-"]').forEach(function (slider) {
      var observer = new MutationObserver(function () {
        if (selectedCounty) setTimeout(updateAllOverlays, 60);
      });
      observer.observe(slider, { attributes: true, subtree: true, attributeFilter: ['class'] });
    });

    /* Image src/srcset changes — variant switch may change image srcs */
    document.querySelectorAll('[id^="GalleryViewer-"] .product__media-item img').forEach(function (img) {
      var srcObserver = new MutationObserver(function () {
        if (selectedCounty) setTimeout(updateAllOverlays, 100);
      });
      srcObserver.observe(img, { attributes: true, attributeFilter: ['src', 'srcset'] });
    });
  }

  /* ── Init ── */

  function init() {
    selectedMaterial = readMaterial();
    selectedCounty  = readCounty();
    bindEvents();
    updateAllOverlays();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();